import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class Image {

  isCallable() {
    return true
  }
  init() {

    gsap.registerPlugin(ScrollTrigger);

    const elements = document.querySelectorAll('[scrolling-down]')
    const elements2 = document.querySelectorAll('[scrolling-up]')

    elements.forEach(element => {
      gsap.to(element, {
        y: "100%",
        rotate: 10,
        scrollTrigger: {
          trigger: element,
          start: "top center",
          end: "bottom top",
          scrub: 2,
          markers: false
        }
      })
    })

    elements2.forEach(element => {
      gsap.to(element, {
        y: "-100%",
        rotate: -10,
        scrollTrigger: {
          trigger: element,
          start: "top center+=250",
          end: "bottom top",
          scrub: 2,
          markers: false
        }
      })
    })

  }
}
